//main page for job preview
import React, { useEffect, useState } from "react";
import BasicDetails from "./basic";
import MCQTestOverview from "./mcq";
import TechnicalInterviewOverview from "./technical";
import HRInterviewOverview from "./HR";
import { useStores } from "../../../store";
import { useObserver } from "mobx-react";

function JobOverview(props) {
  const [user, setUser] = useState({});
  const { RecuiterStore, UserStore, CommonStore } = useStores();
  const checkSalary = (currency, salary) => {
    if (salary === undefined || salary === null) {
      return "N/A";
    }
    if (currency == "₹") {
      if (salary >= 10000000) return `${(salary / 10000000).toFixed(1)} Cr`; // Crore
      if (salary >= 100000) return `${(salary / 100000).toFixed(1)} L`; // Lakh
      if (salary >= 1000) return `${(salary / 1000).toFixed(0)} K`; // Thousand
    } else if (currency == "$") {
      if (salary >= 1000) return `${(salary / 1000).toFixed(0)} K`; // Thousand
    } else if (currency == "€") {
      if (salary >= 1000000) return `${(salary / 1000000).toFixed(1)} M`; // Million
      if (salary >= 1000) return `${(salary / 1000).toFixed(0)} K`; // Thousand
    } else if (currency == "UGX") {
      if (salary >= 1000000) return `${(salary / 1000000).toFixed(1)} M`; // Million
      if (salary >= 1000) return `${(salary / 1000).toFixed(0)} K`; // Thousand
    }
    return salary;
  };

  // const handleMode = () => {
  //   if (mode === "workFromOffice") {
  //     return "work from office";
  //   } else if (mode === "workFromHome") {
  //     return "work from home";
  //   } else {
  //     return "hybrid";
  //   }
  // };

  // const { CommonStore, RecuiterStore } = useStores();

  const formatsalary = (job) => {
    // Extract the currency symbol from the dropdown value
    const currencySymbol =
      RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.currency?.includes(
        "UGX"
      )
        ? "UGX"
        : RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.currency?.split(
            ""
          )[0] ?? "₹";

    const minSalary = checkSalary(
      currencySymbol,
      RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.min
    );
    const maxSalary = checkSalary(
      currencySymbol,
      RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.max
    );
    const salary = checkSalary(
      currencySymbol,
      RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.min
    );

    // Format the salary based on showPayBy value
    const formattedSalary =
      RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.showPayBy ===
      "range"
        ? ` ${minSalary} - ${maxSalary} ` +
          RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.rate.replace(
            "per",
            ""
          )
        : ` ${salary}/` +
          (RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.rate ===
          "perYear"
            ? "Year"
            : RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.rate ===
              "perMonth"
            ? "Month"
            : RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.rate ===
              "perDay"
            ? "Day"
            : RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.rate ===
              "perHour"
            ? "Hour"
            : "");

    return formattedSalary;
  };

  const jobData = {
    jobTitle: RecuiterStore.jobPostDetails.basicJobDetails.jobTitle,
    company: user?.companyName,
    salaryRange: formatsalary(),
    experience: `${RecuiterStore.jobPostDetails.basicJobDetails.experience[0]} - ${RecuiterStore.jobPostDetails.basicJobDetails.experience[1]} `,
    time: RecuiterStore.jobPostDetails.basicJobDetails.parttime,
    mode: RecuiterStore.jobPostDetails.basicJobDetails.workMode,
    openings: RecuiterStore.jobPostDetails.basicJobDetails.openings,
    location: Array.isArray(RecuiterStore.jobPostDetails.basicJobDetails.location)
      ? RecuiterStore.jobPostDetails.basicJobDetails.location
      : RecuiterStore.jobPostDetails.basicJobDetails.location
      ? [RecuiterStore.jobPostDetails.basicJobDetails.location]
      : [],
    jobDescription: RecuiterStore.jobPostDetails.basicJobDetails.jobDescription,
    responsibilities:
      RecuiterStore.jobPostDetails.basicJobDetails.responsibilities,
    requiredSkills: RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills,
    companyLogo: user?.pic,
    qualification: RecuiterStore.jobPostDetails.basicJobDetails.qualification,
    noticePeriod: RecuiterStore.jobPostDetails.basicJobDetails.noticePeriod,
  };

  const mcqTestData = {
    testName: RecuiterStore.jobPostDetails.mcqTestDetails.skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.mcqTestDetails.testName,
    numberOfQuestions: RecuiterStore.jobPostDetails.mcqTestDetails.skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.mcqTestDetails.numberOfQuestions,
    cutOff: RecuiterStore.jobPostDetails.mcqTestDetails.skipped
      ? "Not added"
      : `${RecuiterStore.jobPostDetails.mcqTestDetails.cutOff}`,
    sections: [
      {
        name: "Aptitude",
        questions: RecuiterStore.jobPostDetails.mcqTestDetails.skipped
          ? "Not added"
          : RecuiterStore.jobPostDetails.mcqTestDetails.sections[0].questions,
      },
      {
        name: "Technical",
        questions: RecuiterStore.jobPostDetails.mcqTestDetails.skipped
          ? "Not added"
          : RecuiterStore.jobPostDetails.mcqTestDetails.sections[1].questions,
      },
      {
        name: "Reasoning",
        questions: RecuiterStore.jobPostDetails.mcqTestDetails.skipped
          ? "Not added"
          : RecuiterStore.jobPostDetails.mcqTestDetails.sections[2].questions,
      },
      {
        name: "Verbal",
        questions: RecuiterStore.jobPostDetails.mcqTestDetails.skipped
          ? "Not added"
          : RecuiterStore.jobPostDetails.mcqTestDetails.sections[3].questions,
      },
    ],
  };

  const interviewData = {
    interviewType: RecuiterStore.jobPostDetails.technicalInterviewDetails
      .skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.technicalInterviewDetails
          .technicalInterviewType,
    cutoff: RecuiterStore.jobPostDetails.technicalInterviewDetails.skipped
      ? "Not added"
      : `${RecuiterStore.jobPostDetails.technicalInterviewDetails.resumeCutoff}`,
    interviewLevel: RecuiterStore.jobPostDetails.technicalInterviewDetails
      .skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.technicalInterviewDetails
          .technicalInterviewLevel,
    numberOfQuestions: RecuiterStore.jobPostDetails.technicalInterviewDetails
      .skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.technicalInterviewDetails
          .technicalNumberOfQuestions,
    noOfFollowUps: RecuiterStore.jobPostDetails.technicalInterviewDetails
      .skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.technicalInterviewDetails
          .noOfFollowUps,
    customQuestions: RecuiterStore.jobPostDetails.technicalInterviewDetails
      .skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.technicalInterviewDetails
          .technicalCustomquestions,
  };

  const hrinterviewData = {
    interviewType: RecuiterStore.jobPostDetails.hrInterviewDetails.skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.hrInterviewDetails.interviewType,
    cutOff: RecuiterStore.jobPostDetails.hrInterviewDetails.skipped
      ? "Not added"
      : `${RecuiterStore.jobPostDetails.hrInterviewDetails.resumeCutoff}`,
    interviewLevel: RecuiterStore.jobPostDetails.hrInterviewDetails.skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.hrInterviewDetails.interviewLevel,
    numberOfQuestions: RecuiterStore.jobPostDetails.hrInterviewDetails.skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.hrInterviewDetails.numberOfQuestions,
      noOfFollowUps: RecuiterStore.jobPostDetails.hrInterviewDetails.skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.hrInterviewDetails.noOfFollowUps,
    customQuestions: RecuiterStore.jobPostDetails.hrInterviewDetails.skipped
      ? "Not added"
      : RecuiterStore.jobPostDetails.hrInterviewDetails.customquestions,
  };

  const handleEdit1 = () => {
    CommonStore.setProgress(0);
    console.log("Edit details clicked");
  };

  const handleEdit2 = () => {
    CommonStore.setProgress(1);
    console.log("Edit details clicked");
  };

  const handleEdit3 = () => {
    CommonStore.setProgress(2);
    console.log("Edit details clicked");
  };

  const handleEdit4 = () => {
    CommonStore.setProgress(3);
    console.log("Edit details clicked");
  };

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    setUser(userDetails);
  }, []);

  return useObserver(
    (
      jobTitle,
      company,
      salaryRange,
      experience,
      time,
      mode,
      openings,
      location,
      companyLogo
    ) => (
      <div className="px-5 md:px-16 py-10 mb-8 lg:px-24 gil-reg ">
        <h3 className="text-2xl text-orange-500 font-semibold flex   ml-5 mb-5">
          Preview
        </h3>
        <div className=" shadow-lg pb-5 rounded-b-2xl">
          <div className=" rounded-b-xl container mx-auto ">
            <BasicDetails
              newjobpost={props.newjobpost}
              jobPostId={RecuiterStore?.jobPostId}
              isSalaryDisclosed={RecuiterStore?.jobPostDetails?.basicJobDetails?.salary?.isSalaryDisclosed}
              {...jobData}
              showEditButton={true}
              onEdit={handleEdit1}
              forJobPost={true}
            />
            <MCQTestOverview
              {...mcqTestData}
              showEditButton={true}
              onEdit={handleEdit2}
            />
            <TechnicalInterviewOverview
              forJobPost={true}
              {...interviewData}
              onEdit={handleEdit3}
              showEditButton={true}
            />

            <HRInterviewOverview
              forJobPost={true}
              {...hrinterviewData}
              onEdit={handleEdit4}
              showEditButton={true}
            />
          </div>
        </div>
      </div>
    )
  );
}

export default JobOverview;
